import { useQuery } from '@tanstack/react-query'
import { useState } from 'react'
import { Link } from 'react-router-dom'
import { QueryState } from '../components/QueryState'
import { api } from '../lib/api'
import { URGENCY_LABEL, makeLabeler, useCommonCodes, useDongs, useTargetCodes } from '../lib/codes'

/**
 * 시민문제 목록 — 프로토타입의 4필터(분야·대상·동네·시급성)를 승계한다.
 * 공개되는 것은 운영자가 확정한 구조화 값까지다. 원문은 API가 내려주지 않는다(설계서 C-04).
 */
export function ProblemListPage() {
  const [category, setCategory] = useState('')
  const [target, setTarget] = useState('')
  const [region, setRegion] = useState('')
  const [urgency, setUrgency] = useState('')

  const problems = useQuery({
    queryKey: ['problem-cards', { category, target, region, urgency }],
    queryFn: () => api.problemCards({ category, target, region, urgency, limit: 60 }),
  })

  const categories = useCommonCodes('category')
  const targets = useTargetCodes()
  const dongs = useDongs()

  const categoryLabel = makeLabeler(categories.data)
  const targetLabel = makeLabeler(targets.data)

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'start', gap: 16, flexWrap: 'wrap' }}>
        <div style={{ flex: 1, minWidth: 260 }}>
          <h1 className="page-title">시민문제카드</h1>
          <p className="page-desc">시민이 등록한 동네의 생활 문제입니다.</p>
        </div>
        <Link className="btn" to="/problems/new">
          + 문제 등록
        </Link>
      </div>

      <div className="filters">
        <select value={category} onChange={(e) => setCategory(e.target.value)} aria-label="분야">
          <option value="">분야 전체</option>
          {categories.data?.map((c) => (
            <option key={c.code} value={c.code}>
              {c.label}
            </option>
          ))}
        </select>
        <select value={target} onChange={(e) => setTarget(e.target.value)} aria-label="대상">
          <option value="">대상 전체</option>
          {targets.data?.map((c) => (
            <option key={c.code} value={c.code}>
              {c.label}
            </option>
          ))}
        </select>
        <select value={region} onChange={(e) => setRegion(e.target.value)} aria-label="동네">
          <option value="">동네 전체</option>
          {dongs.data?.map((r) => (
            <option key={r.code} value={r.code}>
              {r.name}
            </option>
          ))}
        </select>
        <select value={urgency} onChange={(e) => setUrgency(e.target.value)} aria-label="시급성">
          <option value="">시급성 전체</option>
          <option value="high">시급</option>
          <option value="mid">보통</option>
          <option value="low">여유</option>
        </select>
      </div>

      <QueryState
        isPending={problems.isPending}
        error={problems.error}
        isEmpty={problems.data?.items.length === 0}
        emptyMessage="조건에 맞는 시민문제가 없습니다."
      >
        <p className="muted small" style={{ marginBottom: 12 }}>
          {problems.data?.total}개 문제
        </p>
        <div className="grid">
          {problems.data?.items.map((p) => (
            <Link key={p.id} className="card" to={`/problems/${p.id}`}>
              <div className="card-org">
                {p.region.name}{' '}
                <span className={`urgency u-${p.urgency}`}>
                  {URGENCY_LABEL[p.urgency] ?? p.urgency}
                </span>
              </div>
              <h3>{p.title}</h3>
              <div className="tags">
                {(p.categoryCodes ?? []).map((code) => (
                  <span key={code} className="tag">
                    {categoryLabel(code)}
                  </span>
                ))}
                {p.targetCodes.map((code) => (
                  <span key={code} className="tag">
                    {targetLabel(code)}
                  </span>
                ))}
              </div>
            </Link>
          ))}
        </div>
      </QueryState>
    </>
  )
}
